var map = {
	"./assignatures/assignatures.artlaindustrial": 7841,
	"./assignatures/assignatures.artlaindustrial.json": 7841,
	"./assignatures/assignatures.castellarnau": 1950,
	"./assignatures/assignatures.castellarnau.json": 1950,
	"./assignatures/assignatures.cavallbernat": 5565,
	"./assignatures/assignatures.cavallbernat.json": 5565,
	"./assignatures/assignatures.ibadia": 6172,
	"./assignatures/assignatures.ibadia.json": 6172,
	"./assignatures/assignatures.jaumemimo": 2811,
	"./assignatures/assignatures.jaumemimo.json": 2811,
	"./assignatures/assignatures.joanoro": 9261,
	"./assignatures/assignatures.joanoro.json": 9261,
	"./assignatures/assignatures.pompeufabra": 4364,
	"./assignatures/assignatures.pompeufabra.json": 4364,
	"./dadesbancaries/dadesbancaries.artlaindustrial": 6686,
	"./dadesbancaries/dadesbancaries.artlaindustrial.json": 6686,
	"./dadesbancaries/dadesbancaries.castellarnau": 9420,
	"./dadesbancaries/dadesbancaries.castellarnau.json": 9420,
	"./dadesbancaries/dadesbancaries.cavallbernat": 9172,
	"./dadesbancaries/dadesbancaries.cavallbernat.json": 9172,
	"./dadesbancaries/dadesbancaries.ibadia": 4422,
	"./dadesbancaries/dadesbancaries.ibadia.json": 4422,
	"./dadesbancaries/dadesbancaries.jaumemimo": 8047,
	"./dadesbancaries/dadesbancaries.jaumemimo.json": 8047,
	"./dadesbancaries/dadesbancaries.joanoro": 2008,
	"./dadesbancaries/dadesbancaries.joanoro.json": 2008,
	"./dadesbancaries/dadesbancaries.pompeufabra": 8696,
	"./dadesbancaries/dadesbancaries.pompeufabra.json": 8696,
	"./families/families.artlaindustrial": 4868,
	"./families/families.artlaindustrial.json": 4868,
	"./families/families.castellarnau": 5552,
	"./families/families.castellarnau.json": 5552,
	"./families/families.cavallbernat": 9196,
	"./families/families.cavallbernat.json": 9196,
	"./families/families.ibadia": 3825,
	"./families/families.ibadia.json": 3825,
	"./families/families.jaumemimo": 3552,
	"./families/families.jaumemimo.json": 3552,
	"./families/families.joanoro": 6904,
	"./families/families.joanoro.json": 6904,
	"./families/families.pompeufabra": 8329,
	"./families/families.pompeufabra.json": 8329,
	"./llista_bonificacions": 4042,
	"./llista_bonificacions.json": 4042
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6482;